// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell__zqKrN","value":"value__3qSzY"};